export { default } from "./CitationGeneratorFooter";
